import { logger } from '@zorro/common-utils';

const createLinkElementForDownload = (
  url: string,
  fileName: string,
  shouldOpenInNewTab: boolean
) => {
  const anchorElement = document.createElement('a');
  anchorElement.setAttribute('href', url);
  anchorElement.setAttribute('download', fileName);
  if (shouldOpenInNewTab) {
    anchorElement.setAttribute('target', '_blank');
  }
  anchorElement.style.visibility = 'hidden';
  document.body.append(anchorElement);
  anchorElement.click();
  anchorElement.remove();
};

export const downloadFile = (
  url: string,
  fileName: string,
  crossOrigin?: boolean | undefined
) => {
  if (crossOrigin) {
    fetch(url)
      .then(async (res) => {
        // An error body is bytes too: saved unchecked it lands on disk under
        // `fileName` as a file nothing can open.
        if (!res.ok) {
          throw new Error(`Download of ${fileName} failed with ${res.status}`);
        }

        const blob = new Blob([await res.blob()]);
        createLinkElementForDownload(
          window.URL.createObjectURL(blob),
          fileName,
          false
        );
      })
      .catch((error) => logger.error('Error downloading file', error));
  } else {
    createLinkElementForDownload(url, fileName, true);
  }
};
